import { SEASONAL_STATES, LOCALIZATION_MAP, TIMEZONES, LOCALIZATION } from '../../utils/constants'

import theme from '../../utils/styles/theme'

const { vip, bfcmCore, bfcmLastChance } = SEASONAL_STATES
const { US, CA, UK, AU } = LOCALIZATION_MAP

const localizedDateMap = {
  [US]: '12/01',
  [CA]: '12/01',
  [UK]: '01/12',
  [AU]: '12/01',
}

export const SEASONAL_PDP_BANNER_CONSTANTS = {
  [vip]: {
    promoHeader: 'VIP EARLY ACCESS:',
    promoSubHeader: {
      preStyledText: 'Use code ',
      styledText: 'EARLYACCESS',
      postStyledText: ' at checkout',
      styledTextColor: theme.mint,
    },
    disclaimerText1: 'Ends 11/18 at 11:59pm PST or while supplies last.',
    discountTextColor: theme.lightMistletoe,
    promoBannerBkgdColor: theme.evergreen,
  },
  [bfcmCore]: {
    promoHeader: 'BLACK FRIDAY DEALS:',
    disclaimerText1: 'Discount automatically applied at checkout.',
    disclaimerText2: `Ends ${localizedDateMap[LOCALIZATION]} at 11:59pm ${TIMEZONES[LOCALIZATION]} or while supplies last.`,
    discountTextColor: theme.mint,
    promoBannerBkgdColor: theme.space,
  },
  [bfcmLastChance]: {
    promoHeader: 'FINAL HOURS TO SAVE:',
    disclaimerText1: 'Discount automatically applied at checkout.',
    disclaimerText2: `Ends ${localizedDateMap[LOCALIZATION]} at 11:59pm ${TIMEZONES[LOCALIZATION]} or while supplies last.`,
    discountTextColor: theme.lightBlush,
    promoBannerBkgdColor: theme.holly,
  },
}

export const SEASONAL_PRODUCT_STATES = {
  ...SEASONAL_PDP_BANNER_CONSTANTS,

  prices: {
    [US]: {
      10: {
        bubble: '$40 OFF',
        discount: '$40',
        regularPrice: '169.99',
        discountedPrice: '129.99',
        discountWithPlus: '$60',
        discountedPriceWithPlus: '109.99',
      },
      15: {
        bubble: '$60 OFF',
        discount: '$60',
        regularPrice: '299.99',
        discountedPrice: '239.99',
        discountWithPlus: '$80',
        discountedPriceWithPlus: '219.99',
      },
      27: {
        bubble: '$100 OFF',
        discount: '$100',
        regularPrice: '599.99',
        discountedPrice: '499.99',
        discountWithPlus: '$130',
        discountedPriceWithPlus: '469.99',
      },
      '27SB': {
        bubble: '$100 OFF',
        discount: '$100',
        regularPrice: '629.99',
        discountedPrice: '529.99',
        discountWithPlus: '$130',
        discountedPriceWithPlus: '499.99',
      },
    },
    [CA]: {
      15: {
        bubble: '$90 OFF',
        discount: '$90',
        regularPrice: '449',
        discountedPrice: '359',
        discountWithPlus: '$120',
        discountedPriceWithPlus: '329',
      },
      27: {
        bubble: '$129 OFF',
        discount: '$129',
        regularPrice: '859',
        discountedPrice: '730',
        discountWithPlus: '$174',
        discountedPriceWithPlus: '685',
      },
    },
    [UK]: {
      15: {
        bubble: '£50 OFF',
        discount: '£50',
        regularPrice: '290',
        discountedPrice: '240',
        discountWithPlus: '£65',
        discountedPriceWithPlus: '225',
      },
      27: {
        bubble: '£80 OFF',
        discount: '£80',
        regularPrice: '550',
        discountedPrice: '467.50',
        discountWithPlus: '£107',
        discountedPriceWithPlus: '442.50',
      },
    },
    [AU]: {
      15: {
        bubble: '$100 OFF',
        discount: '$100',
        regularPrice: '529',
        discountedPrice: '429',
        discountWithPlus: '$120',
        discountedPriceWithPlus: '409',
      },
      27: {
        bubble: '$150 OFF',
        discount: '$150',
        regularPrice: '1199',
        discountedPrice: '1049',
        discountWithPlus: '$220',
        discountedPriceWithPlus: '979',
      },
    },
  },
}
